import { Mail, Phone, Linkedin, MapPin } from "lucide-react";
import usePageMeta from "@/lib/usePageMeta";
import SectionHead from "@/components/SectionHead";
import { Reveal } from "@/components/Reveal";
import ContactForm from "@/components/forms/ContactForm";
import { CONTACT } from "@/lib/data";

const CHANNELS = [
  { icon: Mail, label: "Email", value: CONTACT.email, href: `mailto:${CONTACT.email}`, id: "email" },
  { icon: Phone, label: "Phone", value: CONTACT.phone, href: `tel:${CONTACT.phoneRaw}`, id: "phone" },
  { icon: Linkedin, label: "LinkedIn", value: "linkedin.com/company/talentifystaffing", href: CONTACT.linkedin, id: "linkedin" },
  { icon: MapPin, label: "Location", value: CONTACT.location, href: null, id: "location" },
];

export default function Contact() {
  usePageMeta(
    "Contact Talentify | Recruitment Consultants India",
    "Get in touch with Talentify for IT and Non-IT recruitment support across PAN India. Email hello@talentifyhs.com or call +91 70161 20977."
  );
  return (
    <main>
      <section className="relative overflow-hidden pb-24 pt-40">
        <div className="pointer-events-none absolute inset-0" style={{ background: "radial-gradient(circle at 50% -20%, rgba(56,189,248,0.12), transparent 60%)" }} />
        <div className="relative mx-auto max-w-7xl px-6">
          <SectionHead
            overline="Contact"
            title="Let's Build Your Next Team."
            sub="Whether you're hiring one critical position or building an entire team, Talentify is ready to support your recruitment requirements."
            testid="contact-page-heading"
          />
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_1.3fr]">
            <div className="space-y-4">
              {CHANNELS.map((c, i) => (
                <Reveal key={c.id} delay={i * 0.07}>
                  {c.href ? (
                    <a
                      href={c.href}
                      {...(c.id === "linkedin" ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                      data-testid={`contact-channel-${c.id}`}
                      className="group flex items-center gap-4 rounded-2xl border border-white/[0.08] bg-[#0A0F1D]/60 p-5 transition-[border-color,background-color] duration-300 hover:border-sky-400/30 hover:bg-[#0F172A]/70"
                    >
                      <span className="grid h-11 w-11 place-items-center rounded-xl border border-white/[0.08] bg-white/[0.03] text-sky-400">
                        <c.icon size={18} />
                      </span>
                      <span>
                        <span className="block font-mono text-[10px] uppercase tracking-[0.22em] text-slate-500">{c.label}</span>
                        <span className="block text-sm font-medium text-slate-200">{c.value}</span>
                      </span>
                    </a>
                  ) : (
                    <div data-testid={`contact-channel-${c.id}`} className="flex items-center gap-4 rounded-2xl border border-white/[0.08] bg-[#0A0F1D]/60 p-5">
                      <span className="grid h-11 w-11 place-items-center rounded-xl border border-white/[0.08] bg-white/[0.03] text-sky-400">
                        <c.icon size={18} />
                      </span>
                      <span>
                        <span className="block font-mono text-[10px] uppercase tracking-[0.22em] text-slate-500">{c.label}</span>
                        <span className="block text-sm font-medium text-slate-200">{c.value}</span>
                      </span>
                    </div>
                  )}
                </Reveal>
              ))}
            </div>
            <Reveal delay={0.15}>
              <div className="glass-card rounded-3xl p-7 sm:p-10">
                <p className="mb-6 font-mono text-[11px] uppercase tracking-[0.25em] text-sky-400">Send a Message</p>
                <ContactForm />
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </main>
  );
}
